import { useEffect, useState } from "react";

export const useScrollTop = (threshold = 100) => {
  const [scrolled, setScrolled] = useState(false);
  const [first, setFirst] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > threshold);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [threshold]);

  return scrolled;
};
